import gql from 'graphql-tag';

export const SITEINI_OPERATION_COOKIES_RAW = `
  mutation ($input: SiteiniOperationCookieInput!){
    siteiniOperationCreateCookie(input: $input) {
      id
      site
      cookies
    }
  }
`;

export const SITEINI_OPERATION_COOKIES = gql`${SITEINI_OPERATION_COOKIES_RAW}`;



// WEBPACK FOOTER //
// ./src/graphql/mutations/siteini_operation/cookies.js